<template>
    <rkm-area title="Materiais">
        <Form
            :data="data"
            ref="Form"
        />

        <List
            :data="data"
            @click-to-edit="$refs.Form.loadToEdit($event)"
            ref="List"
        />
    </rkm-area>
</template>

<script>
import Form from './Form'
import List from './List'

export default {
    components: { Form, List },
    props: {
        data: { type: Object, required: true }
    }
}
</script>